import React, { useEffect, useMemo, useState } from "react";
import { NumberFormatBase } from "react-number-format";

import { Field } from "formik";
import { FormControl, FormLabel, Box, FormErrorMessage, Input } from "@chakra-ui/react";
import useModalPrice from "~components/Modal/hooks/useModalPrice";
import ModalPriceSearch from "~components/Modal/ModalPriceSearch";
import useProgress from "~components/CreditProgress/hooks/useProgress";
import { LessIconInput, MoreIconInput, TimesIcon } from "~misc/icons";
const CurrencyInput = ({
  inputName,
  labelName,
  pure,
  valuePure,
  input,
  setInput,
  button,
  center,
  valueDefault,
  isRequired,
  errors,
  touched,
  onBlur,
  inputBg,
  resetFieldAction,
  showResetFieldButton,
}) => {
  const { isModalOpenPrice, closeModalPrice, openModalPrice } = useModalPrice();
  const [error, setError] = useState();

  useEffect(() => {
    if (error == "Valor de Sell In maior que Sell Out") {
      openModalPrice();
    }
  }, [error]);

  function currencyFormatter(value) {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return 0;
    }

    const amount = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);

    return `${amount}`;
  }

  function removingFormatting(value) {
    const numeric = value.replace(/[^\d,]/g, "").replace(",", ".");

    const number = Number(numeric);
    if (isNaN(number)) {
      return 0;
    }
    return number;
  }

  return (
    <>
      <Field name={inputName}>
        {({ field, meta }) => (
          <FormControl isInvalid={meta.error && meta.touched || errors && touched}>
            <FormLabel className="field__label">
              {labelName}{" "}
              {isRequired && <span className="text-red-500">*</span>}
            </FormLabel>
            <Box position="relative currency-input">
              <Input
                style={{
                  backgroundColor: inputBg ?? "",
                }}
                className={center == true ? "search-wrapper searchWrapper text-center" : "search-wrapper searchWrapper"}
                as={NumberFormatBase}
                format={currencyFormatter}
                {...field}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if(pure){
                    valuePure(removingFormatting(inputValue))
                  }
                  setInput(removingFormatting(inputValue));
                }}
                readOnly={button}
                onBlur={onBlur}
              />
              {showResetFieldButton && (
                <button
                  type="button"
                  className="absolute top-1/2 -translate-y-1/2 right-[0] z-[10] scale-75"
                  onClick={() => resetFieldAction()}
                >
                  <TimesIcon fill="#000" />
                </button>
              )}
            </Box>

            {meta.touched && meta.error && setError(meta.error)}
            {meta.touched && meta.error ? (
              <FormErrorMessage>{meta.error}</FormErrorMessage>
            ) : errors && touched ? (
              <FormErrorMessage>{errors}</FormErrorMessage>
            ) : null}

            <ModalPriceSearch
              isOpen={isModalOpenPrice}
              onClose={() => {
                closeModalPrice();
              }}
              title="Aviso!"
              sub={
                <>
                  <p className="font-bold max-w-[200px]">Valor de Sell In maior que Sell Out</p>
                </>
              }
              buttonOne={null}
              buttonTwo="Ok"
              linkOne={null}
              linkTwo={null}
            />
          </FormControl>
        )}
      </Field>
    </>
  );
};

export default CurrencyInput;
